import SeriesAccessIdentifier from 'components_v1/aloAccessBadge/SeriesAccessIdentifier'
import ProgramInfo from 'components_v1/programs/ProgramInfo'
import React, { useContext } from 'react'
import styled from 'styled-components'
import ProgramMain from './ProgramMain'
import ProgramTabs from './ProgramTabs'
import { ProgramViewContext } from 'components_v2/page_context'

const Main = styled.div`
  .plan-cover {
    background-image: url('${({ mobileImg }) => mobileImg}');
  }

  @media (min-width: 768px) {
    .plan-cover {
      background-image: url('${({ deskImg }) => deskImg}');
    }
  }
  .pdp-series-save {
    order: unset !important;
  }
`

const ProgramHeader = () => {
  const { plan, user, setPlan, tab, fetchPlan } = useContext(ProgramViewContext)

  return (
    <>
      <Main
        deskImg={plan?.bannerPhotoUrl}
        mobileImg={plan?.bannerPhotoMobileUrl || plan?.bannerPhotoUrl}
      >
        <div className='bundle-plan-cover-container'>
          <div
            className='header-cover-container bundle-cover plan-cover'
            data-page-cover=''
          />
          <div className='series-access-identifier'>
            <SeriesAccessIdentifier
              user={user}
              product={{ availabilityGating: plan?.availabilityGating }}
            />
          </div>
          <div className='plan-bundle-label-container ref-container'>
            <div className='workout-information-container'>
              <ProgramInfo
                plan={plan}
                user={user}
                fetchPlan={fetchPlan}
                setPlan={setPlan}
                type='Plan'
              />
            </div>
          </div>
        </div>
        {user?.admin && (
          <div className='adminActions'>
            <a
              href={`/admin/plans/${plan.id}/edit`}
              target='_blank'
              className='btn alo-button'
              rel='noreferrer'
            >
              Edit Program
            </a>
          </div>
        )}
        <ProgramTabs />
      </Main>
      {tab === 'overview' && (
        <div className='container-bundle plan-container-bundle'>
          <div className='grid-bundle'>
            <div>
              <ProgramMain />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ProgramHeader
